import React from 'react';
import './terms.css';

function TermsAndConditions() {
  return (
    <div className="terms-container">
      <h1 className="terms-title">Terms and Conditions</h1>
      
      <div className="terms-section">
        <h2>Introduction</h2>
        <p>Welcome to Chavo Tours! These Terms and Conditions govern your use of our website and services. By accessing or using our services, you agree to comply with these terms. Please read them carefully.</p>
      </div>

      <div className="terms-section">
        <h2>Services Provided</h2>
        <p>Chavo Tours offers transportation services, tour bookings, and related travel services. We provide our services to registered users, and the booking process is subject to our policies.</p>
      </div>

      <div className="terms-section">
        <h2>Eligibility</h2>
        <p>To use our services, you must be at least 18 years old or have the consent of a legal guardian. By using our services, you confirm that you meet these eligibility requirements.</p>
      </div>

      <div className="terms-section">
        <h2>User Responsibilities</h2>
        <ul>
          <li>Provide accurate and complete information during the booking process.</li>
          <li>Abide by all local laws and regulations while using our services.</li>
          <li>Respect the rights and privacy of other users.</li>
        </ul>
      </div>

      <div className="terms-section">
        <h2>Payment and Pricing</h2>
        <p>All prices are listed in the local currency and are subject to change. Payments must be made before the service is provided. Chavo Tours accepts various forms of payment including credit/debit cards and online transfers.</p>
      </div>

      <div className="terms-section">
        <h2>Cancellation and Refund Policy</h2>
        <p>Cancellation requests must be made at least 48 hours before the scheduled tour. If a cancellation is made within this period, a refund will be provided, subject to a cancellation fee. No refund will be issued for cancellations made less than 48 hours before the tour.</p>
      </div>

      <div className="terms-section">
        <h2>Privacy and Data Protection</h2>
        <p>Your privacy is important to us. We collect personal data for the purpose of providing our services, and we ensure that all information is stored securely in compliance with data protection laws.</p>
      </div>

      <div className="terms-section">
        <h2>Limitation of Liability</h2>
        <p>Chavo Tours is not liable for any indirect, special, or consequential damages resulting from the use of our services. Our liability is limited to the amount paid for the services you have booked.</p>
      </div>

      <div className="terms-section">
        <h2>Changes to Terms</h2>
        <p>We reserve the right to modify these Terms and Conditions at any time. Any changes will be posted on this page, and it is your responsibility to review these terms periodically.</p>
      </div>

      <div className="terms-section">
        <h2>Contact Us</h2>
        <p>If you have any questions regarding these Terms and Conditions, please contact us at <a href="mailto:infochavotours@gmail.com">infochavotours@gmail.com</a>.</p>
      </div>
    </div>
  );
}

export default TermsAndConditions;
